var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_44-gitlab"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.752,205.501l203.18,264.07l-222.7-165.29c-6.11-4.59-8.72-12.58-6.38-19.771l25.87-79.05       L52.752,205.501z",
    style: {
      fill: "#FCA326"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "171.302,205.461 256.012,469.541 255.932,469.571 52.752,205.501 52.812,205.461             ",
    style: {
      fill: "#FC6D26"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "340.731,205.461 256.021,469.571 256.012,469.541 171.302,205.461 171.392,205.461        340.642,205.461      ",
    style: {
      fill: "#E24329"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "459.292,205.501 256.021,469.571 340.731,205.461 459.231,205.461      ",
    style: {
      fill: "#FC6D26"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485.191,284.511c2.24,7.19-0.27,15.181-6.47,19.771l-222.7,165.29l203.271-264.07l0.029-0.04       L485.191,284.511z",
    style: {
      fill: "#FCA326"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M408.472,48.421l50.76,157.04h-118.5h-0.09l50.85-157.04       C394.361,40.431,405.682,40.431,408.472,48.421z",
    style: {
      fill: "#E24329"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.392,205.461h-0.09H52.812l50.76-157.04c2.87-7.99,14.19-7.99,16.98,0       C120.552,48.421,171.302,205.461,171.392,205.461z",
    style: {
      fill: "#E24329"
    }
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabLogo);
export default __webpack_public_path__ + "static/media/gitlabLogo.79e05d3fd19115cd13afacc56b261157.svg";
export { ForwardRef as ReactComponent };